module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/particular04-978c5e3abca86cf9a3807e3c56eb16e4.png";